import svgUrl from "ni:svgr;fVpts_4YCpIYdLg2y5Ug-0uPAzuuCm1WCgjPjuh-S4M";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const EnrichmentFirecrawlMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><g filter="var(--tbl--ui-node-icon--enrichment--firecrawl-m)"><text fill="currentColor" textAnchor="middle" x="50%" y="50%" dy=".5em" fontSize="23px">{"\uD83D\uDD25"}</text></g><defs><filter id="tbl--ui-node-icon--enrichment--firecrawl-m--disabled"><feColorMatrix type="saturate" values={0.01} /></filter></defs></svg>;
const Memo = memo(EnrichmentFirecrawlMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "EnrichmentFirecrawlMIcon";
}